<template>
  <div class="examQuesList">
    <div class="list">
      <div class="select-wrap">
        <div class="box-wrap clearfix">
          <p class="state-intro">
            <span><i class="icon-state-yes" />已答试题</span>
            <span><i class="icon-state-no" />未答试题</span>
            <span><i class="icon-state-mark" />标记试题</span>
          </p>
          <div class="quesNumList">
            <div class="ques-sheet"
                 v-if="questions">
              <dl v-for="(item, index) in questions"
                  :key="index">
                <dt>{{ item.viewTypeName }}</dt>
                <dd v-if="item.list">
                  <a v-for="(ele, index1) in item.list"
                     :key="index1"
                     @click="toggleQues(index,index1)"
                     :class="sign(ele)"
                     v-show="signType===1 ? true : ((signType=== 2 && ele.isAnswer !== 1) ? true : ((signType === 3 && ele.isMark === 1)?true:false))">
                    {{ ele.showSerialNum }}
                  </a>
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <div class="bottom"></div>
      </div>
    </div>
    <div class="button clearfix">
      <div class="fl">
        <a href="javascript:void(0)"
           class="a1"
           @click="savePaper">结束检查</a>
      </div>
      <div class="opt fr">
        <a href="javascript:void(0)"
           class="a2"
           @click="showQuesList(1)">显示全部试题</a>
        <a href="javascript:void(0)"
           class="a2"
           @click="showQuesList(2)">显示未答试题</a>
        <a href="javascript:void(0)"
           class="a2"
           @click="showQuesList(3)">显示标记试题</a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ExamQuesList',
  computed: {
    ...mapGetters(['questions', 'currentQuestion']),
  },
  data() {
    return {
      signType: 1, // 默认展示全部
    }
  },
  methods: {
    //  切换题目(答题卡)
    toggleQues(quesType, quesIndex) {
      this.$emit('quesFn', quesType, quesIndex, this.currentQuestion)
    },
    //  答题卡标记字符
    sign(ques) {
      if (ques.isMark === 1 && ques.isAnswer !== 1) {
        return 'mark'
      } else if (
        ques.isAnswer === 1 &&
        (ques.isMark === 0 || ques.isMark === null)
      ) {
        return 'yes'
      } else if (ques.isAnswer === 1 && ques.isMark === 1) {
        return 'mark yes'
      } else {
        return ''
      }
    },
    backToPaper() {
      this.$emit('backToPaper', false)
    },
    savePaper() {
      this.$emit('savePaper')
    },
    showQuesList(type) {
      this.signType = type
    },
  },
}
</script>
<style lang="scss" scoped>
$imgUrl: '~@/assets/images/doExam/';
dl {
  border-bottom: 1px solid #ebf2fc;
  padding: 15px 0px 5px 60px;

  dt {
    display: inline-block;
    float: left;
    width: 110px;
    padding-right: 20px;
    text-align: right;
    font-weight: bold;
  }

  dd {
    display: inline-block;
    width: 650px;

    a {
      border: 1px solid #ccc;
      color: #32639b;
      display: inline-block;
      text-align: center;
      width: 50px;
      padding: 5px 0;
      margin-right: 10px;
      margin-bottom: 10px;
      background-color: #d9e5f5;
      text-decoration: none;
    }

    a:hover {
      text-decoration: none;
      background-color: #e5f0fa;
    }

    a.yes {
      background-color: #349802 !important;
      color: #fff;
    }

    a.mark {
      background: #d9e5f5 url($imgUrl + 'icon-mark.png') no-repeat top right;
    }
  }
}
</style>
